<style scoped lang="scss">
.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.nav.nav-pills {
  margin-bottom: 10px;
}
</style>

<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>E-Mail Einstellungen</h4>
      </div>
      <div class="card-body">
        <ul class="nav nav-pills" id="myTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#verbindungen"
              role="tab"
              >Verbindungen</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#mailChannel" role="tab"
              >Mail-Channel</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#testnachrichten"
              role="tab"
              >Testnachrichten</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#createEMailConnection"
              role="tab"
              >Mail-Connection-Setting erstellen</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#EMailLog" role="tab"
              >E-Mail Log</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="verbindungen"
            role="tabpanel"
          >
            <div class="form-group row">
              <col-label>Verbindung auswählen</col-label>
              <div>
                <div class="col-12">
                  <select
                    class="custom-select"
                    id="mail-setting-selector"
                    v-model="selectedMailConnectionSetting"
                    placeholder="Mail-Setting wählen"
                  >
                    <option
                      v-for="mailConnectionSetting in mailConnectionSettings"
                      :value="mailConnectionSetting"
                      :key="mailConnectionSetting.id"
                      >{{ mailConnectionSetting.name }}</option
                    >
                  </select>
                </div>
              </div>
              <div v-if="selectedMailConnectionSetting" class="col-12">
                <div class="selected-mail-settings">
                  <div class="form-group">
                    <hr />
                    <div class="form-group row">
                      <col-label>Host</col-label>
                      <div class="col-8">
                        {{ selectedMailConnectionSetting.host }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <col-label>Port</col-label>
                      <div class="col-8">
                        {{ selectedMailConnectionSetting.port }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <col-label>Username</col-label>
                      <div class="col-8">
                        {{ selectedMailConnectionSetting.username }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <col-label>Password</col-label>
                      <div class="col-8">
                        <input
                          type="password"
                          id="maskedPassword"
                          style="border: 0"
                          v-model="selectedMailConnectionSetting.password"
                        />
                        <i
                          v-if="!isConnectionSelected()"
                          class="far fa-eye fa-2x"
                          @mousedown="maskPassword(false)"
                          @mouseleave="maskPassword(true)"
                          @mouseup="maskPassword(true)"
                          @touchstart="maskPassword(false)"
                          @touchend="maskPassword(true)"
                          @touchcancel="maskPassword(true)"
                        >
                        </i>
                      </div>
                    </div>
                    <div class="form-group row">
                      <col-label>Encryption</col-label>
                      <div class="col-8">
                        {{ selectedMailConnectionSetting.encryption }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <col-label>"From" Mail-Address</col-label>
                      <div class="col-8">
                        {{ selectedMailConnectionSetting.address }}
                      </div>
                    </div>
                    <div class="form-group row">
                      <col-label>"From" Name</col-label>
                      <div class="col-8">
                        {{ selectedMailConnectionSetting.senderName }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <v-button
                      :disabled="!selectedMailConnectionSetting"
                      @click="$modal.show(editMailConnectionSettingModalName)"
                      class="btn btn-warning"
                      >bearbeiten</v-button
                    >
                    <v-button
                      :disabled="!selectedMailConnectionSetting"
                      @click="deleteMailConnectionSetting"
                      class="btn btn-danger"
                      >löschen</v-button
                    >
                  </div>
                </div>
                <div>
                  <modal
                    :name="editMailConnectionSettingModalName"
                    :maxWidth="600"
                    width="90%"
                    height="auto"
                    :adaptive="true"
                    style="overflow: hidden"
                  >
                    <resource
                      resource="mailConnectionSetting"
                      resourceName="Mail-Connection-Setting bearbeiten"
                      :original="original"
                      @resource-persisted="updatedMailConnectionSetting"
                      :attributes="[
                        {
                          name: 'id',
                          type: 'hidden'
                        },
                        {
                          name: 'name',
                          label: 'Name'
                        },
                        {
                          name: 'host',
                          label: 'Host'
                        },
                        {
                          name: 'port',
                          label: 'Port'
                        },
                        {
                          name: 'username',
                          label: 'Username'
                        },
                        {
                          name: 'password',
                          label: 'Password'
                        },
                        {
                          name: 'encryption',
                          label: 'Encryption',
                          items: options,
                          resource: 'encryption',
                          type: 'DropdownSelector'
                        },
                        {
                          name: 'address',
                          label: '\'From\' Mail-Adresse'
                        },
                        {
                          name: 'senderName',
                          label: '\'From\' Name'
                        }
                      ]"
                    >
                      <div slot="title">
                        <h4>Mail-Connection-Setting bearbeiten</h4>
                      </div>
                    </resource>
                  </modal>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade show" id="mailChannel" role="tabpanel">
            <div class="form-group row">
              <div class="col-12">
                <div class="form-group row">
                  <col-label>Rundmail</col-label>
                  <div class="col-8">
                    <weighted-chance-selector
                      v-model="data.mailConnectionSetting_channel_circular"
                      :items="mailConnectionSettings"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Registrierung</col-label>
                  <div class="col-8">
                    <weighted-chance-selector
                      v-model="data.mailConnectionSetting_channel_member"
                      :items="mailConnectionSettings"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Support</col-label>
                  <div class="col-8">
                    <weighted-chance-selector
                      v-model="data.mailConnectionSetting_channel_supportticket"
                      :items="mailConnectionSettings"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Bezahlung</col-label>
                  <div class="col-8">
                    <weighted-chance-selector
                      v-model="data.mailConnectionSetting_channel_payment"
                      :items="mailConnectionSettings"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Löschung</col-label>
                  <div class="col-8">
                    <weighted-chance-selector
                      v-model="data.mailConnectionSetting_channel_admin"
                      :items="mailConnectionSettings"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Offline</col-label>
                  <div class="col-8">
                    <weighted-chance-selector
                      v-model="data.mailConnectionSetting_channel_offline"
                      :items="mailConnectionSettings"
                    />
                  </div>
                </div>
              </div>
            </div>
            <v-button
              @click.native="updateSettings()"
              class="btn btn-primary float-right"
              >speichern</v-button
            >
          </div>
          <div class="tab-pane fade show" id="testnachrichten" role="tabpanel">
            <div class="form-group row">
              <col-label>Testnachrichten schicken an:</col-label>
              <div class="col-8">
                <input
                  type="email"
                  class="form-control"
                  id="inputTestEmailAddress"
                  v-model="testEmailAddress"
                />
                <v-button
                  @click.native="sendTestEmails()"
                  type="button"
                  class="btn-primary float-right"
                  >senden</v-button
                >
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="createEMailConnection"
            role="tabpanel"
          >
            <resource
              resource="mailConnectionSetting"
              resourceName="Mail-Connection-Setting erstellen"
              :attributes="[
                {
                  name: 'name',
                  label: 'Name'
                },
                {
                  name: 'host',
                  label: 'Host'
                },
                {
                  name: 'port',
                  label: 'Port'
                },
                {
                  name: 'username',
                  label: 'Username'
                },
                {
                  name: 'password',
                  label: 'Password'
                },
                {
                  name: 'encryption',
                  label: 'Encryption',
                  type: 'DropdownSelector',
                  items: options
                },
                {
                  name: 'address',
                  label: '\'From\' Mail-Adresse'
                },
                {
                  name: 'senderName',
                  label: '\'From\' Name'
                }
              ]"
            >
            </resource>
          </div>
          <div class="tab-pane fade show" id="EMailLog" role="tabpanel">
            <div class="form-group row">
              <col-label>E-Mail Log</col-label>
              <div class="col-8">
                <div class="custom-control custom-checkbox">
                  <input
                    class="form-check-input custom-control-input"
                    type="checkbox"
                    v-model="data.eMailLog"
                    id="watermarkEnable"
                  />
                  <label
                    class="form-check-label custom-control-label"
                    for="watermarkEnable"
                    >aktiv</label
                  >
                </div>
              </div>
            </div>
            <div class="form-group row">
              <col-label>Expire (Tage)</col-label>
              <div class="col-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="data.eMailLogExpire"
                />
              </div>
            </div>
            <v-button @click.native="deleteEMailLog()" class="btn btn-danger"
              ><i class="fa fa-trash"></i> E-Mail Log löschen</v-button
            >
            <v-button
              @click.native="updateSettings()"
              class="btn btn-primary float-right"
              >speichern</v-button
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="babel">
import WeightedChanceSelector from "src/components/UIComponents/Inputs/WeightedChanceSelector.vue"

export default {
  components: {
    WeightedChanceSelector
  },
  data() {
    return {
      data: {
        mailConnectionSetting_channel_circular: [],
        mailConnectionSetting_channel_offline: [],
        mailConnectionSetting_channel_payment: [],
        mailConnectionSetting_channel_supportticket: [],
        mailConnectionSetting_channel_member: [],
        mailConnectionSetting_channel_admin: [],
      },
      testEmailAddress: Laravel.user.email,
      options: [{
        value: 'none',
        text: 'none',
      },{
        value: 'tls',
        text: 'tls',
      },{
        value: 'ssl',
        text: 'SSL',
      }],
      selectedMailConnectionSetting: null,
      mailChannel: ['circular','offline','payment','supportticket','member','admin'],
    };
  },
  created() {
    Promise.all([
      this.$store.dispatch("mailConnectionSetting/read"),
      this.$store.dispatch("setting/all")
    ]).then(() => {
      let settings = this.$store.getters["setting/all"];
      let settingsToParse = this.mailChannel.map(c => 'mailConnectionSetting_channel_'+c)
      Object.keys(settings).forEach(key => {
        //for mailConnectionSetting_channel_xxxxx the setting needs to be parsed from JSON
        if (settingsToParse.includes(key)){
          this.data[key] = JSON.parse(settings[key])
            .map(channelOptions => {
              //reattach the name because it is not stored in the database
              channelOptions.name = this.mailConnectionSettings
                .find(con => con.id == channelOptions.id)
                .name
              return channelOptions;
            })
        } else {
          this.data[key] = settings[key];
        }
      });
    });
  },
  computed: {
    disableConnectionButtons() {
      return this.isConnectionSelected();
    },
    editMailConnectionSettingModalName() {
      return `${this.id}`;
    },
    id() {
      return this.selectedMailConnectionSetting ? this.selectedMailConnectionSetting.id : null;
    },
    mailConnectionSettings() {
      let tmp = this.$store.getters["mailConnectionSetting/mailConnectionSettings"];
      return tmp ? tmp : [];
    },
    original() {
      return this.$store.getters['mailConnectionSetting/find'](this.id);
    },
  },
  methods: {
    updatedMailConnectionSetting($updatedMailConnectionSettingObject){
      this.$modal.hide(this.editMailConnectionSettingModalName);
      this.selectedMailConnectionSetting = $updatedMailConnectionSettingObject;
    },
    isConnectionSelected() {
      return this.selectedMailConnectionSetting.id === undefined;
    },
    deleteMailConnectionSetting() {
      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }
      this.$store.dispatch('mailConnectionSetting/delete', { url: this.selectedMailConnectionSetting.delete_url, id: this.id}).then(() => {
        this.$notify({
          title: "Einstellung gelöscht",
          type: "success"
        });
        this.$store.commit("mailConnectionSetting/delete", this.id);
        this.selectedMailConnectionSetting = null;
      }).catch(response => {
        this.$notify({
          title: response.response.data.message,
          type: "error"
        });
      });
    },
    sendTestEmails() {
      this.$http
        .post(
          `/api/v1/mailConnectionSetting/test/${
            this.testEmailAddress
          }`
        )
        .then(() => {
          this.$notify({
            title: "Test Emails wurden versendet",
            type: "success"
          });
        })
        .catch(error => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$notify({
              title: error.response.data.message,
              type: "error"
            });
          }
        });
    },
    updateSettings() {
      let data = {...this.data};
      this.mailChannel.map(channel => 'mailConnectionSetting_channel_'+channel)
        .forEach(channel => {

          let tmp = data[channel].map(connection => ({id: connection.id, chance: connection.chance}))
          data[channel] = JSON.stringify(tmp)
        })
      const saveMailChannel = Object.assign({}, data );
      this.$store.dispatch("setting/update", saveMailChannel).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    },
    maskPassword(hide) {
      const hiddenPassword = document.querySelector('#maskedPassword');
      hide ? hiddenPassword.setAttribute('type', 'password') : hiddenPassword.setAttribute('type', 'text');
    },
    deleteEMailLog() {
      this.$http
        .delete("/api/v1/emailLog")
        .then(() => {
          this.$notify({
            title: "Der E-Mail Log wurde gelöscht",
            type: "success"
          });
        });
    },
  },
};
</script>
